import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import "./App.css";
import "./Queries.css";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Functionalities from "./components/Functionalities";
import About from "./components/About";
import Features from "./components/Features";
import Achievements from "./components/Achievements";

function App() {
  return (
    <ChakraProvider>
      <div className="App">
        <NavBar />
        <Hero />
        <About />
        <Functionalities />
        <Features />
        <Achievements />
        <Faq />
        <Contact />
        <Footer />
      </div>
    </ChakraProvider>
  );
}

export default App;
